// JavaScript Document
BookingApp.controller('FlightsSingleWayController',function($scope,$routeParams,FlightServices,$filter,$http,$location){
    $scope.SortBy = 'Fare.TotalFare';
    $scope.SortingOrder = false;

    $scope.SortByReturn = 'Fare.TotalFare';
    $scope.SortingOrderReturn = false;

    $scope.ShowFilter = false;

    //DoubleWay Flight Codeing part
    $scope.InbondFlight = false;
    $scope.OutbondFlight = false;
    $scope.setInbondFlight = function(f){ $scope.InbondFlight  = f;}
    $scope.setOutbondFlight = function(f){ $scope.OutbondFlight  = f;}

    $scope.setCheapest = function(list,type){

        var cheapestFlight = false;

        angular.forEach(list,function (flight,index) {
            if(!cheapestFlight){
                cheapestFlight = flight
            }else if(flight.Fare.TotalFare < cheapestFlight.Fare.TotalFare ){
                cheapestFlight = flight;
            }
        });

        if(type == 'departure'){
            $scope.setInbondFlight(cheapestFlight);
        }else{
            $scope.setOutbondFlight(cheapestFlight);
        }
    };

    $scope.init = function() {
        FlightServices.setMinMaxPrice($scope.$resolve.data.flights);
        $scope.trace = $scope.$resolve.data.trace;
        var ArlnDupl = $scope.$resolve.data.Inbond.Airlines.concat($scope.$resolve.data.Outbond.Airlines)
        var ConnDupli = $scope.$resolve.data.Inbond.ConnectingAirports.concat($scope.$resolve.data.Outbond.ConnectingAirports)

        $scope.Airlines = ArlnDupl.filter(function(value,index,self){
            return self.indexOf(value) === index
        });

        $scope.ConnectingAirports = ConnDupli.filter(function(value,index,self){
            return self.indexOf(value) === index
        });

        $scope.ArrivalAirport = $scope.$resolve.data.ArrivalAirport;

        $scope.DepartAirport = $scope.$resolve.data.DepartAirport;
        $scope.isDomestic = $scope.$resolve.data.Destination.cc == $scope.$resolve.data.Origin.cc;

        $scope.InMaxPrice = FlightServices.getPrice('max');

        $scope.Filters = {
            Price :  {
                minPrice:FlightServices.getPrice('min'),
                maxPrice:FlightServices.getPrice('max'),
                RangeOption:50,
                options:{
                    floor:FlightServices.getPrice('min'),
                    ceil:FlightServices.getPrice('max'),
                    step:5,
                    translate: function(value) {
                        return '<i class="fa fa-rupee"></i> ' + value;
                    }
                }
            },
            Stops:[],
            Refundable:[],
            Lcc:[],
            Airline:[],
            CA:[],
            DA:[],
            AA:[],
            IEMFT:false,  //Inbound Only Early Morning Flight Timing
            IMFT:false,   //Inbound Only Moring Flight Timing
            IMDFT:false,  //Inbound Only Mid Day Flight Timing
            INFT:false,    //Inbound Only Night Flight Timing
            NoConvenience:0,
            BA:0 //Baggage Allowance
        };

        FlightServices.setMinMaxPrice($scope.$resolve.data.returnFlights);
        $scope.OutMaxPrice = FlightServices.getPrice('max');
        $scope.ReturnFilters = {
            Price :  {
                minPrice:FlightServices.getPrice('min'),
                maxPrice:FlightServices.getPrice('max'),
                RangeOption:50,
                options:{
                    floor:FlightServices.getPrice('min'),
                    ceil:FlightServices.getPrice('max'),
                    step:1,
                    translate: function(value) {
                        return '<i class="fa fa-rupee"></i> ' + value;
                    }
                }
            },
            Stops:[],
            Refundable:[],
            Lcc:[],
            Airline:[],
            CA:[],
            DA:[],
            AA:[],
            IEMFT:false,  //Inbound Only Early Morning Flight Timing
            IMFT:false,   //Inbound Only Moring Flight Timing
            IMDFT:false,  //Inbound Only Mid Day Flight Timing
            INFT:false,    //Inbound Only Night Flight Timing
            NoConvenience:0,
            BA:0 //Baggage Allowance
        };


        $scope.flights = $scope.$resolve.data.flights;
        $scope.returnFlights = angular.isDefined($scope.$resolve.data.returnFlights) ?  $scope.$resolve.data.returnFlights : false;

        if($scope.returnFlights){
            $scope.setCheapest($scope.$resolve.data.flights,'departure')
            $scope.setCheapest($scope.$resolve.data.returnFlights,'return')
        }

        FlightServices.getAirportCity($routeParams.origin).then(function(r){ $scope.request.origin = r });
        FlightServices.getAirportCity($routeParams.destination).then(function(r){ $scope.request.destination = r });

        $("input[type='checkbox']").attr("checked",false);
    }
    $scope.init();

    $scope.changeTab = function(d){
        $scope.FilterTab = d
    }


    $scope.sortByReturn = function(type){
        if($scope.SortByReturn == type){
            $scope.SortingOrderReturn = (!$scope.SortingOrderReturn);
        }else{
            $scope.SortByReturn = type;
            $scope.SortingOrderReturn = true
        }
    }

    $scope.sortBy = function(type){
        if($scope.SortBy == type){
            $scope.SortingOrder = (!$scope.SortingOrder);
        }else{
            $scope.SortBy = type;
            $scope.SortingOrder = true
        }
    }

    $scope.toggalFilter = function($filter,$value){
        var index = $scope.Filters[$filter].indexOf($value);
        if(index === -1){
            $scope.Filters[$filter].push($value)
        }else{
            $scope.Filters[$filter].splice(index,1)
        }
    }

    $scope.toggalFilterReturn = function($filter,$value){
        var index = $scope.ReturnFilters[$filter].indexOf($value);
        if(index === -1){
            $scope.ReturnFilters[$filter].push($value)
        }else{
            $scope.ReturnFilters[$filter].splice(index,1)
        }
    }



    $scope.request = $routeParams;
    $scope.request.journeyDate = moment($routeParams.journeyDate, 'YYYYMMDD');
    if($scope.request.JourneyType == 2){
        $scope.request.returnDate = moment($routeParams.returnDate,'YYYYMMDD')
    }else{
        $scope.request.returnDate = $scope.request.journeyDate.clone();
        $scope.request.returnDate.add(5,'days');
    }

    //$scope.request.



    //Modufy Search section
    $scope.request.travellers = function(){
        return (parseInt($scope.request.adult) + parseInt($scope.request.child) + parseInt($scope.request.infant));
    }



    $scope.datePicker   = {
        options : {
            singleDatePicker : $scope.request.JourneyType == 1,
            autoApply:true,
            autoUpdateInput:false
        },
        min: new Date(),
        date : ($scope.request.JourneyType == 1) ? $scope.request.journeyDate : {
            startDate: $scope.request.journeyDate,
            endDate: angular.isDefined($scope.request.returnDate) ? $scope.request.returnDate : null
        }
    }

    $scope.$watch('request["JourneyType"]',function(n,v){
        $scope.datePicker.options.singleDatePicker = $scope.request.JourneyType == 1
        if($scope.request.JourneyType != 1){
            $scope.datePicker.options.autoUpdateInput = true
        }
        $scope.datePicker.date = ($scope.request.JourneyType == 1) ? $scope.request.journeyDate : {
                startDate: $scope.request.journeyDate,
                endDate: angular.isDefined($scope.request.returnDate) ? $scope.request.returnDate : NextDate.clone()
            }
    });

    $scope.getOrigins = function (val){
        return $http.get('https://' + window.location.hostname + '/flights/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });;
    }

    $scope.getDestination = function(val){
        return $scope.getLocation(val);
    }

    $scope.getLocation = function (val){
        return $http.get('https://' + window.location.hostname + '/flights/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });
    }


    $scope.TravellerOpen = false;
    $scope.OpenTravellerPopUp = function(){
        $scope.TravellerOpen = true;
    }
    $scope.closepopup = function(){
        $scope.TravellerOpen = false;
    }

    $scope.searchFlight = function(){
        var request = {};//$scope.request;
        //console.log($scope.request.JourneyType);return;
        if($scope.request.JourneyType == 2 )
        {
            request.startDate = $scope.datePicker.date.startDate.format('YYYYMMDD');
            request.endDate =   $scope.datePicker.date.endDate.format('YYYYMMDD');
            //console.log(request);
            if($scope.datePicker.date.endDate == null) return;
            $('#modifysearch').modal('hide')
            $location.path('flights/search/from-'+ $scope.request.origin.city_code + '-to-' + $scope.request.destination.city_code + '-on-' + request.startDate + '-' + request.endDate + '-' + $scope.request.JourneyType + '-' + $scope.request.adult + '-' + $scope.request.child + '-' + $scope.request.infant + '-' + $scope.request.class);
        }
        else
        {
            request.JourneyDate = $scope.datePicker.date.format('YYYYMMDD');
            $('#modifysearch').modal('hide')
            $location.path('flights/search/from-'+ $scope.request.origin.city_code + '-to-' + $scope.request.destination.city_code + '-on-' + request.JourneyDate + '-' + $scope.request.JourneyType + '-' + $scope.request.adult + '-' + $scope.request.child + '-' + $scope.request.infant + '-' + $scope.request.class);
        }
    }
})

